import React, { useEffect, useState } from "react";
import img1 from "../../Images/Carousal/1.jpg";
// import '../../Components/Carousal/style.css'
import ExploreSaudi from '../../Pages/Home/ExploreSaudi'

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Carousel from "react-bootstrap/Carousel";
import SearchBar from "../../Components/SearchBar/Searchbar";

import adimage from "../../Images/Home/qurbani_ad.jpeg";
import Hotels from "../../Components/Hotel/Hotels";
import MorePackages from "../../Components/MorePackages/MorePackages";
import Layout from "../../Components/Layout/Layout";
import Loader from "../../Components/Loading/Loader";
import Helmet from "react-helmet";
import wow from "wowjs";
import 'animate.css';
import { useNavigate, NavLink } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";

import home1 from "../../Images/New/image_home_mix_1.jpg";
import home2 from "../../Images/New/image_home_mix_2.jpg";
import home3 from "../../Images/New/image_home_mix_3.jpg";
import IndexComponents from "./IndexComponents";


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import img4 from "../../Images/Carousal/5.jpg";


import bb1 from '../../img/bb1.png'
import bb2 from "../../img/bb2.png";
import b1 from "../../img/b1.png";
import b2 from  "../../img/b2.png"

import Dollar from "../../img/dollar.png";
import Support from "../../img/support.png";

function Home() {
  const [isLoading, setIsLoading] = useState(true);
  const [bottomAdd, setShowbottomAdd] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [valueFromChild, setValueFromChild] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    new wow.WOW().init();

    const fetchData = async () => {
      await new Promise((resolve) => setTimeout(resolve, 2000));
      setIsLoading(false);
    };

    fetchData();
  }, []);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const hideadd = () => {
    setShowbottomAdd(false);
  };
  const gotoHajjPage = () => {
    navigate("/hajj");
  };
  const handleValueChange = (newValue) => {
    setValueFromChild(newValue);
  };
  const sty = {
    background: `url(${img4}) no-repeat`,
    backgroundSize: "cover",
    height: "100%",
  };

  // const [selectedTab, setSelectedTab] = useState(1);
  // const [tab, setTab] = useState(1);

  // const goToClick = (p) => {
  //   // debugger
  //   setSelectedTab(p);
  //   console.log(p);
  //   // Set the selected tab
  // };

  // const click = (n) => {
  //   setTab(n);
  //   console.log(n);
  // };
  return (
    <>
      {isLoading && <Loader />}
      <Layout>
        <div className="banner-bg" style={sty}>
          <div className="container">
            <div className="row wow animate__animated animate__bounceIn">
              <div className="col-12 col-sm-12 col-md-12 col-lg-7 align-content-center">
                <div className="search-bg">
                  <SearchBar onValueChange={handleValueChange} />
                </div>
              </div>




              {/* --------------side banner----------- */}
              <div className="col-12 col-sm-12 col-md-12 col-lg-5 gy-2 my-2">
  <div className="row gy-2">
    {/* --------------banner 1----------------- */}
    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-12">
      <div
        id="carouselExampleIndicators1"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators1"
            data-bs-slide-to="0"
            className="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators1"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
        </div>
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src={b1} className="d-block w-100" alt="..." />
          </div>
          <div className="carousel-item">
            <img src={b2} className="d-block w-100" alt="..." />
          </div>
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleIndicators1"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleIndicators1"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>

    {/* --------------------banner 2------------------ */}
    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-12">
      <div
        id="carouselExampleIndicators2"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators2"
            data-bs-slide-to="0"
            className="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators2"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
        </div>
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src={bb1} className="d-block w-100" alt="..." />
          </div>
          <div className="carousel-item">
            <img src={bb2} className="d-block w-100" alt="..." />
          </div>
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleIndicators2"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleIndicators2"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  </div>
</div>

            </div>
          </div>
        </div>

        {/* --------------------offer-------------------- */}
        <section className="best-flight-bg">
          {/* <!--Offer--> */}
          <div className="container">
            <div className="row wow animate__animated animate__bounceIn">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <a class="best-bg">
                  <img src={Dollar} alt="" />

                  <span>BEST PRICE GUARANTEED</span>

                  <small>
                    Find a lower price? We'll refund you 100% of the difference.
                  </small>
                </a>
              </div>

              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                <a class="support-bg">
                  <img src={Support} alt="" />

                  <span>24×7 SUPPORT</span>

                  <small>
                    We’re always here for you – reach us 24 hours a day, 7 days
                    a week.
                  </small>
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* --------------------Popular Destinations --------------- */}
        {/* <section className="tour">
          <div className="container">
            <h2 className="title1">
              <strong>Popular Destinations</strong>
            </h2>

            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-3">
                <NavLink className="tour-block">
                  <img src={location1} alt="" />

                  <h2>Makkah</h2>
                </NavLink>
              </div>

              <div className="col-xs-12 col-sm-6 col-md-3">
                <NavLink  className="tour-block">
                  <img src={location2} alt="" />

                  <h2>Madina</h2>
                </NavLink>
              </div>

              <div className="col-xs-12 col-sm-6 col-md-3">
                <NavLink  className="tour-block">
                  <img src={location3} alt="" />

                  <h2>Riyadh</h2>
                </NavLink>
              </div>

              <div className="col-xs-12 col-sm-6 col-md-3">
                <NavLink  className="tour-block">
                  <img src={location4} alt="" className="tourimg" />

                  <h2>Jeddah</h2>
                </NavLink>
              </div>
            </div>
           
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-12">

            
              </div>
            </div>
          </div>
        </section> */}
        <ExploreSaudi />

        {/* <IndexComponents /> */}

        



   


      </Layout>
    </>
  );
}

export default Home;
